import { PaymentMethod } from '@appliedsystems/payments-core';
import { AvailablePaymentMethod } from 'src/components/HostedPaymentPageContainer/types';

export function getAppliedPaymentMethod(adyenPaymentMethod: string) {
  if (adyenPaymentMethod === 'eft_directdebit_CA') {
    return PaymentMethod.Eft;
  }
  if (adyenPaymentMethod === 'ach') {
    return PaymentMethod.Ach;
  }
  if (adyenPaymentMethod === 'scheme') {
    return PaymentMethod.Card;
  }

  // should never happen
  return adyenPaymentMethod as AvailablePaymentMethod;
}
